import { baseApi } from '../baseApi';

import { MessagePreset } from './MessagePreset';

const messagePresetSlice = baseApi
  .enhanceEndpoints({
    addTagTypes: ['MessagePresets'],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getMessagePresets: builder.query<MessagePreset[], void>({
        keepUnusedDataFor: 60,
        query: () => ({
          url: '/MessagePresets',
          method: 'GET',
          headers: {
            'x-api-version': '1.0',
          },
        }),
        providesTags: (result) =>
          result
            ? [
                ...result.map(({ id }) => ({
                  type: 'MessagePresets' as const,
                  id,
                })),
                { type: 'MessagePresets', id: 'LIST' },
              ]
            : [{ type: 'MessagePresets', id: 'LIST' }],
      }),
    }),
  });

export const { useGetMessagePresetsQuery, useLazyGetMessagePresetsQuery } = messagePresetSlice;
